import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "instant-break-wrapper" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = {
  id: "break-time",
  class: "form-select-field"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = {
  for: "break-message",
  class: "form-label"
}
const _hoisted_7 = { class: "action-buttons" }
const _hoisted_8 = { class: "btn btn-blue" }

import { computed, inject, reactive } from "vue";
  import { trans } from "@/utils/trans";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'InstantBreakPopup',
  emits: ["closeForm", "changeTitle", "setModalHeightAuto"],
  setup(__props, { emit: __emit }) {

  const emit = __emit;
  const emitter = inject("emitter");

  const timeOptions = Array.from({ length: 48 }, (_, i) => (i + 1) * 5);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("select", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeOptions), (time) => {
          return (_openBlock(), _createElementBlock("option", {
            key: time,
            value: `${time} min`
          }, _toDisplayString(`${time} min`), 9, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(trans)("live.common.instant_break.pinned_message")), 1),
      _cache[0] || (_cache[0] = _createElementVNode("textarea", {
        id: "break-message",
        class: "form-textarea-field textarea"
      }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", _hoisted_8, _toDisplayString(_unref(trans)("live.common.instant_break.start_break")), 1)
    ])
  ]))
}
}

})